<template>
  <div class="ad-slot" v-if="size !== 'fixed'">
    <!-- Autosize -->
    <ins class="adsbygoogle"
      style="display:block"
      data-ad-client="ca-pub-5966530933996695"
      data-ad-slot="3478600497"
      data-ad-format="auto"
      data-full-width-responsive="true">
    </ins>
  </div>
  <div class="ad-slot" v-else>
    <!-- Homepage -->
    <ins class="adsbygoogle"
      style="display:inline-block;width:100%;height:90px"
      data-ad-client="ca-pub-5966530933996695"
      data-ad-slot="9205569895">
    </ins>
  </div>
</template>
 <script>
 export default {
   name: "GoogleAdvertComponent",
   props: {
     size: {
      type: String,
      default: 'response',
    },
   },
 }
 </script>
